import { render, staticRenderFns } from "./bktjS.vue?vue&type=template&id=700a6e6a&scoped=true"
import script from "./bktjS.vue?vue&type=script&lang=js"
export * from "./bktjS.vue?vue&type=script&lang=js"
import style0 from "./bktjS.vue?vue&type=style&index=0&id=700a6e6a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "700a6e6a",
  null
  
)

export default component.exports